<template>
  <div
      class="onls-sub-card"
      @click="emits('click:item', plan)"
  >
    <div class="text-uppercase color-primary onls-sub-card__title">
      {{ plan.name }}
    </div>

    <div class="d-flex flex-column">
      <div
          v-for="(option, o) in planOptions"
          :key="o"
          :class="[
              'onls-sub-card__option',
              { 'onls-sub-card__option--with-dot': planOptions.length > 1 },
            ]"
      >
        {{ option }}
      </div>

      <div class="onls-sub-card__price">
        <div class="d-flex align-end">
              <span class="text-h2">
                $
                {{ plan.price }}</span
              >
          <div v-if="+plan.price !== 0" class="text-h3 d-flex">
            <span>/ </span>
            <span v-if="isAnnual">{{ yearText }}</span>
            <span v-else>{{ monthText }}</span>
          </div>
        </div>

        <small-arrow-icon />
      </div>
    </div>

    <slot name="bottom"></slot>
  </div>
</template>

<script setup lang="ts">
import {computed, PropType} from "vue";
import { SmallArrowIcon } from "../index";

const props = defineProps({
  plan: { type: Object as PropType<Record<string, any>>, required: true },
  isAnnual: { type: Boolean, required: true },
  lang: { type: String, default: 'en' },
  monthText: { type: String, default: 'month' },
  yearText: { type: String, default: 'year' },
})

const emits = defineEmits(['click:item']);

defineSlots<{
  bottom(): any
}>()

const planOptions = computed(() => {
  return props.plan!.description.replaceAll(/[-]/g, "").split(`\n`);
})
</script>

<style lang="scss">
.onls-sub-card {
  min-width: 330px;
  cursor: pointer;
  border: 1px solid var(--secondary-text);
  border-radius: 5px;
  padding: 50px;

  &:hover {
    background: #f2f2f2;
  }

  &__title {
    margin-bottom: 23px;
    font-size: 20px;
  }

  &__option {
    position: relative;
    color: var(--secondary-text);
    font-size: 16px;
    margin-bottom: 20px;
    line-height: 200%;
    font-weight: 300;

    &:last-child {
      margin-bottom: 0;
    }

    &--with-dot {
      margin-left: 10px;
      font-weight: 400;
      line-height: 16px;

      &::before {
        content: "";
        position: absolute;
        height: 6px;
        width: 6px;
        background: var(--secondary-text);
        border-radius: 50%;
        top: 50%;
        left: -10px;
        transform: translateY(-50%);
      }
    }
  }

  &__price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    color: var(--primary-text);

    &-month {
      margin-left: 20px;
    }

    .small-arrow-icon {
      min-width: 31px;
      margin-left: 20px;

      path {
        fill: var(--primary-text);
      }
    }
  }
}

.dark-theme {
  .onls-sub-card {
    &:hover {
      background: #000000;
    }
  }

}
</style>
